import { COLOR_MAP, COLORI_MAPPINGS, COLOR_TRANSLATION } from '../constants/colorConstants';

export const formatColorForDisplay = (colorName) => {
  if (!colorName) return '';

  // Gestisci i casi speciali
  if (colorName === 'GI/VE') return 'Giallo/Verde';
  if (colorName === 'YE/GN') return 'Yellow/Green';

  // Per tutti gli altri colori, prima lettera maiuscola e resto minuscolo
  return colorName.charAt(0).toUpperCase() + colorName.slice(1).toLowerCase();
};

export const getColorsForLanguage = (language) => {
  return COLORI_MAPPINGS[language] || COLORI_MAPPINGS.it;
};

export const translateColor = (color, targetLanguage) => {
  if (!color) return color;

  // Se il colore è già nella lingua target, restituiscilo
  if (COLORI_MAPPINGS[targetLanguage].includes(color)) {
    return color;
  }

  // Altrimenti traduci
  return COLOR_TRANSLATION[color] || color;
};

